import { useAtom } from 'jotai';
import { loadableTermsOfUseAtom } from '../../../atoms/termsOfUseAtoms';
import { Box, Typography, CircularProgress } from '@mui/material';
import { ComponentProps } from 'react';

const BoxContent = () => {
  const [value] = useAtom(loadableTermsOfUseAtom);

  if (value.state === 'hasError') {
    return <Typography>{'利用規約の取得に失敗しました'}</Typography>;
  }

  if (value.state === 'loading') {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        height={'100%'}
      >
        <CircularProgress />
      </Box>
    );
  }

  // return term of use
  return (
    <Typography sx={{ whiteSpace: 'pre-line' }}>{value.data.terms}</Typography>
  );
};

const TeamsOfUseBox = (props: ComponentProps<typeof Box>) => {
  return (
    <Box
      {...props}
      display={'flex'}
      justifyContent={'center'}
      alignContent={'center'}
      border={'1px solid'}
      borderColor={'gray'}
      borderRadius={'10px'}
      sx={{
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        paddingX: 1,
        paddingY: 1,
        // padding: 2,
      }}
    >
      {BoxContent()}
    </Box>
  );
};

export default TeamsOfUseBox;
